module.exports = __webpack_public_path__ + "static/media/left-arrow.53eb09d3.svg";